export default __webpack_public_path__ + "static/media/Asia.36c7d230.webp";